import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';

import { LoginService } from '../auth/login/login.service';
import { FarmerFinanceQuoteService } from './financequote.service';
import { ClientTableDataService } from '../table/table.service';
import { PortalService } from '../../auth/portal.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { CurrencyPipe } from '@angular/common';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-farmerfinancequote',
    templateUrl: './financequote.component.html',
    styleUrls: ['./financequote.component.scss'],
    imports: [
      FormsModule, 
      MatSlider, 
      MatSliderThumb, 
      MatFormField, 
      MatLabel, 
      MatInput, 
      MatDatepickerInput,
      MatDatepickerToggle, 
      MatSuffix, 
      MatDatepicker, 
      MatCheckbox, 
      CurrencyPipe]
})
export class FarmerFinanceQuoteComponent implements OnInit {
	clickedIndex;
  dataStore;
  holidays: Date[] = [];
  SABankHolidays: Date[] = [];
  private readonly currentDate = new Date();
  public minDate = new Date();
  public maxDate = new Date();
  

  constructor(
  	private lS: LoginService,
    public tS: ClientTableDataService,
    public fQ: FarmerFinanceQuoteService,
    public pS: PortalService,
    private cdr: ChangeDetectorRef,
    ) { }

  ngOnInit() {
    this.minDate.setDate(this.currentDate.getDate() + 2);
    this.maxDate.setDate(this.currentDate.getDate() + 16);  
    this.populateHolidays();
  }

  ngAfterViewInit() {
  }

  isAuthenticated(option = null) {
    if (option==null) {
      return this.lS.isAuthenticated();
    }
    if (this.pS.portalMod()[option] || this.pS.portalMod()['mod-all']) {
      return this.lS.isAuthenticated();
    } return false;
  }

  isActive(option, setting) {
    var ans = false;
    if (this.isAuthenticated(option)) {
      for (var i = 0; i < this.pS.portalMod()['settings'].length; i++) {
        if (this.pS.portalMod()['settings'][i]['setting']==setting) {
          ans = (this.pS.portalMod()['settings'][i]['value']==1);
        }
      }
    }
    return ans;
  }

  onInputChange(event: any) {
    this.tS.p_amount = event.value;
    this.tS.setQuoteAmount();    
  }

  onInput(event: any) {
    var num = event.replace(/[^\d.-]/g, '');
    this.tS.p_amount = num;
    this.tS.setQuoteAmount();   
  }

  async requestquotation() {
    var result = await this.lS.loadData('checkBankDetails');
    if (result['messagetype']!='success') {
      this.lS.toast("Details need updating",result['message'], result['messagetype'], 5000);
    } else {
      await this.fQ.requestquotation(this.tS.fquote, this.fQ.p_payment_date);
      this.quoteReview();
    }
  }

  quoteReview() {
    document.getElementById("popup").style.display = "block";
    document.getElementById('popup').scrollTop = 0;
  }

  async acceptQuote() {
    var result = await this.fQ.acceptquotation(this.tS.fquote, this.fQ.p_payment_date);
    if (result['message']==undefined) {
      this.lS.toast("Advanced Payment Quote","Your request has been accepted. This request will require you to sign " + (this.tS.fquote.length>1 ? this.tS.fquote.length + ' contracts' : ' 1 contract') + ". You will shortly recieve emails with further instructions.",'success',5000);
    } else {
      const messagetype = (result['messagetype']==undefined, 'success', result['messagetype']);
      this.lS.toast("Advanced Payment Quote",result['message'], messagetype, 5000);
    }
    this.resetPopup();
  }

  cancelQuote() {
    this.lS.toast("Advanced Payment Quote","You cancelled the quote.",'warn');
    this.resetPopup();
  }

  resetPopup() {
    this.fQ.policyChecked = false;
    document.getElementById("popup").style.display = "none";  
  }

  dateClass = (date: moment.Moment): string | undefined => {
    const isHoliday = this.holidays.some(holiday =>
      date.date() === holiday.getDate() &&
      date.month() === holiday.getMonth() &&
      date.year() === holiday.getFullYear()
    );
    return isHoliday ? 'holiday' : undefined;
  };

  holidayFilter = (date: moment.Moment | null | undefined): boolean => {
    if (!date) {
      return true;
    }
    return !this.holidays.some(holiday =>
      date.date() === holiday.getDate() &&
      date.month() === holiday.getMonth() &&
      date.year() === holiday.getFullYear()
    );
  };

  onDateChange(event: MatDatepickerInputEvent<Date | null>) {
    this.fQ.p_payment_date = event.value;
  }

  async populateHolidays() {
    this.SABankHolidays = await this.lS.loadData('getSAHolidays');
    const today = new Date();
    const threeWeeksFromToday = new Date(today);
    threeWeeksFromToday.setDate(today.getDate() + 21);

    let currentDate = new Date(today);
    while (currentDate <= threeWeeksFromToday) {
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        this.holidays.push(new Date(currentDate));
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    this.SABankHolidays.forEach(holiday => {
      this.holidays.push(new Date(holiday['date']));
    });
    this.fQ.p_payment_date = this.findSoonestNonHoliday(this.holidays);
  }

  findSoonestNonHoliday(holidays) {
    const twoDaysFromNow = new Date(this.currentDate);
    twoDaysFromNow.setDate(this.currentDate.getDate() + 2);
    let currentDate = new Date(twoDaysFromNow);
    const holidaysSet = new Set(holidays.map(date => date.toDateString()));

    while (true) {
      const currentDateString = currentDate.toDateString();
      if (!holidaysSet.has(currentDateString)) {
        return currentDate;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return currentDate;
  }

}
